import { Link } from "react-router-dom";
import { ServiceCard } from "@/components/site/ServiceCard";

const PROMISES = [
  ["Direction", "when you're lost."],
  ["Support", "when you're struggling."],
  ["Understanding", "when nothing makes sense."],
];

export const OurPromise = ({ statement }) => (
  <section className="container-site py-16 md:py-24" aria-labelledby="promise-heading" data-testid="home-promise">
    <p className="eyebrow mb-3">Our promise</p>
    <h2 id="promise-heading" className="sr-only">Our promise</h2>
    <div className="grid gap-6 lg:grid-cols-[1.4fr_1fr] items-end">
      <ul className="space-y-2">
        {PROMISES.map(([a, b]) => (
          <li key={a} className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.08]">
            <span className="text-teal">{a}</span> <span className="italic text-ink-soft font-normal">{b}</span>
          </li>
        ))}
      </ul>
      <blockquote className="border-l-4 border-sage pl-6 text-lg text-ink" data-testid="promise-statement">{statement}</blockquote>
    </div>
  </section>
);

export const AboutIntro = ({ text }) => (
  <section className="container-site py-12 md:py-20" aria-labelledby="about-intro-heading">
    <div className="grid gap-10 lg:grid-cols-2 items-center rounded-[2.5rem] bg-sage-light p-6 sm:p-10 lg:p-14">
      <img src="/images/family.jpg" alt="A family gathered around a wooden table with mugs, talking together" className="w-full h-[280px] sm:h-[380px] object-cover rounded-[2rem]" />
      <div>
        <p className="eyebrow mb-3">About Addiction &amp; Us</p>
        <h2 id="about-intro-heading" className="text-3xl sm:text-4xl">For the people standing alongside addiction.</h2>
        <p className="mt-5 text-ink-soft text-lg">{text}</p>
        <Link to="/about" className="btn-secondary mt-8" data-testid="home-our-story-btn">Our Story</Link>
      </div>
    </div>
  </section>
);

export const TrustedSupport = ({ services = [] }) => (
  <section className="container-site py-16 md:py-24" aria-labelledby="trusted-heading" data-testid="home-trusted-support">
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
      <div className="max-w-2xl">
        <p className="eyebrow mb-3">Trusted UK support</p>
        <h2 id="trusted-heading" className="text-3xl sm:text-4xl">Established organisations who can help.</h2>
        <p className="mt-4 text-ink-soft">These are independent organisations. We list them to help you find support. We are not affiliated with or endorsed by them.</p>
      </div>
      <Link to="/directory" className="btn-primary shrink-0" data-testid="home-view-directory-btn">View the full directory</Link>
    </div>
    <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
      {services.slice(0, 6).map((s) => <ServiceCard key={s.slug} entry={s} compact />)}
    </div>
  </section>
);
